import { _ } from "../../../polyglot/polyglot.js";
import { defaultSearch } from "../../../elements/select/migration.js";
import { range } from "@foretagsplatsen/core-helpers/array";
import AbstractFormStep from "../../AbstractFormStep.js";

/**
 * Wizard step asking the user to select a fiscal year.
 */
export default class FiscalYearStep extends AbstractFormStep {
	_populateForm(form) {
		const currentYear = new Date().getFullYear();

		const items = range(currentYear, 2000, -1).map((year) => ({
			label: year,
			value: year,
			match: (searchString) => year.toString().match(searchString),
		}));

		form.newDropDownField({
			label: _("Fiscal year"),
			attribute: "fiscalYearNumber",
			items,
			dataTestName: "fiscal-year-number",
			onSelection: () => {
				this.changed.trigger();
			},
			searchable: defaultSearch({ items }),
			selected: currentYear,
		});
	}
}
